<ac-layer acFor="let polyline of polylines$" [context]="this" [show]="show">
  <ac-polyline-desc props="{
              width : 8,
              positions: polyline.positions,
              material: polyline.material,
            }">
  </ac-polyline-desc>
</ac-layer>
